import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip, withStyles, Typography } from "@material-ui/core";
import Aux from "../../../hoc/Auxilliary";
import {
  getSessionCalender,
  clearErrorMessage,
  clearErrorStatusCode,
} from "../../../reduxSlices/selectClassSlice";
import MessageIndicator from "../../SnackBar";
import { isObjectEmpty } from "../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../reduxSlices/loginSlice";
import Backdrop from "../../Backdrop";
import getDay from "date-fns/getDay";
import getMonth from "date-fns/getMonth";
import localizedStrings from "../../../utils/localize";
import "./schedule.css";

function Events({ event }) {
  const originalStartTime = event.start;
  const utcStartMoment = moment.utc(originalStartTime);
  const formattedOriginalStartTime = utcStartMoment.format("hh:mm A");
  const originalEndTime = event.end;
  const utcEndMoment = moment.utc(originalEndTime);
  const formattedOriginalEndTime = utcEndMoment.format("hh:mm A");
  return (
    <span>
      <HtmlTooltip
        title={
          <>
            <Typography>
              {" "}
              <strong>Title </strong>: {event.title}
            </Typography>
            <Typography>
              {" "}
              <strong>Start date </strong>:
              {moment(event.start).format("DD/MM/YYYY")}
            </Typography>
            <Typography>
              {" "}
              <strong>End date </strong>:{" "}
              {moment(event.end).format("DD/MM/YYYY")}
            </Typography>
          </>
        }
      >
        <strong>
          {formattedOriginalStartTime} - {formattedOriginalEndTime}
          <br />
          {event.title}
          <br />
          {event.room}
        </strong>
      </HtmlTooltip>
    </span>
  );
}

function EventAgenda({ event }) {
  return (
    <span>
      <em style={{ color: "magenta" }}>{event.ses_session}</em>
    </span>
  );
}

const localizer = momentLocalizer(moment);

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);
const Schedule = (props) => {
  const dispatch = useDispatch();
  const [events, setEvent] = useState([]);
  const [studentId, setStudentId] = useState("");
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const errorMessage = useSelector(
    (state) => state.selectClassData.errorMessage,
  );
  const eventsData = useSelector(
    (state) => state.selectClassData.sessionCalender,
  );
  const errorStatusCode = useSelector(
    (state) => state.selectClassData.errorStatusCode,
  );
  const dataFetchingStatus = useSelector(
    (state) => state.selectClassData.dataFetchingStatus,
  );
  const getStudentDetails = useSelector(
    (state) => state.applicationData.applicantStatus.ses_applicantstatus,
  );

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  useEffect(() => {
    if (getStudentDetails) {
      setStudentId(getStudentDetails.ses_studentid);
    }
  }, [getStudentDetails]);
  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  useEffect(() => {
    if (studentId) {
      dispatch(getSessionCalender(studentId));
    }
  }, [studentId]);
  useEffect(() => {
    if (eventsData && eventsData.length > 0) {
      const sortedData = [...eventsData].sort(
        (a, b) => new Date(a.ses_start) - new Date(b.ses_start),
      );
      setEvent(
        sortedData.map((event) => {
          return {
            start: event.ses_start,
            end: event.ses_stop,
            title: event.ses_classname,
            room: event.ses_roomname,
          };
        }),
      );
    }
  }, [eventsData]);

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    props.history.push("/login");
  };
  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
  };

  const customWeekdays = localizedStrings.general.weekdays;
  const customMonths = localizedStrings.general.year;
  const views = {
    month: true,
  };
  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={error.message}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <div style={{ minHeight: "47vh", width: "100%", margin: "15px 0" }}>
        <Calendar
          localizer={localizer}
          defaultDate={new Date()}
          defaultView="month"
          events={events}
          components={{
            event: Events,
            agenda: {
              event: EventAgenda,
            },
          }}
          style={{ height: "100vh" }}
          formats={{
            weekdayFormat: (date, culture, localizer) =>
              customWeekdays[getDay(date, localizer)],
            monthHeaderFormat: (date, culture, localizer) =>
              `${
                customMonths[getMonth(date, localizer)]
              } ${date.getFullYear()}`,
            dateFormat: "D",
          }}
          views={views}
          messages={{
            next: localizedStrings.general.next,
            previous: localizedStrings.general.back,
            today: localizedStrings.general.today,
            month: localizedStrings.general.month,
          }}
        />
      </div>
    </Aux>
  );
};

export default Schedule;
